var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8125 33.9688V38.75M17.1875 24.4062H17.2031V24.4222H17.1875V24.4062ZM17.1875 29.1875H17.2031V29.2034H17.1875V29.1875ZM17.1875 33.9688H17.2031V33.9847H17.1875V33.9688ZM17.1875 38.75H17.2031V38.7659H17.1875V38.75ZM22.3907 24.4062H22.4064V24.4222H22.3907V24.4062ZM22.3907 29.1875H22.4064V29.2034H22.3907V29.1875ZM22.3907 33.9688H22.4064V33.9847H22.3907V33.9688ZM22.3907 38.75H22.4064V38.7659H22.3907V38.75ZM27.6093 24.4062H27.6249V24.4222H27.6093V24.4062ZM27.6093 29.1875H27.6249V29.2034H27.6093V29.1875ZM27.6093 33.9688H27.6249V33.9847H27.6093V33.9688ZM27.6093 38.75H27.6249V38.7659H27.6093V38.75ZM32.8125 24.4062H32.8281V24.4222H32.8125V24.4062ZM32.8125 29.1875H32.8281V29.2034H32.8125V29.1875ZM17.1875 13.25H32.8125V18.0312H17.1875V13.25ZM25 5.28125C21.0583 5.28125 17.1699 5.51386 13.3473 5.96637C11.0543 6.23779 9.375 8.25413 9.375 10.6086V41.9375C9.375 44.5781 11.4737 46.7188 14.0625 46.7188H35.9375C38.5263 46.7188 40.625 44.5781 40.625 41.9375V10.6086C40.625 8.25413 38.9457 6.23779 36.6528 5.96637C32.8301 5.51386 28.9417 5.28125 25 5.28125Z",
    stroke: "#90CC61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalc);
export default __webpack_public_path__ + "static/media/calc.7a5e06a7dbc626c2b948142d18c2d27a.svg";
export { ForwardRef as ReactComponent };